export default __webpack_public_path__ + "static/media/sign_up_background.13e772e3.jpg";